export const GET_CUSTOMER_RECENT_NOTES = "GET_CUSTOMER_RECENT_NOTES";
export const GOT_CUSTOMER_RECENT_NOTES = "GOT_CUSTOMER_RECENT_NOTES";
export const UPDATE_IS_CUSTOMER_NOTE_EDITOR_OPEN =
  "UPDATE_IS_CUSTOMER_NOTE_EDITOR_OPEN";
export const UPDATE_NEW_CUSTOMER_NOTE = "UPDATE_NEW_CUSTOMER_NOTE";
export const UPDATE_EDITING_NOTE = "UPDATE_EDITING_NOTE";
export const UPDATE_EXPANDED_NOTE_ID = "UPDATE_EXPANDED_NOTE_ID";
export const SAVE_NEW_CUSTOMER_NOTE = "SAVE_NEW_CUSTOMER_NOTE";
export const SAVED_NEW_CUSTOMER_NOTE = "SAVED_NEW_CUSTOMER_NOTE";
export const DELETE_CUSTOMER_NOTE = "DELETE_CUSTOMER_NOTE";
export const DELETED_CUSTOMER_NOTE = "DELETED_CUSTOMER_NOTE";
export const SAVE_EDIT_CUSTOMER_NOTE = "SAVE_EDIT_CUSTOMER_NOTE";
export const SAVED_EDIT_CUSTOMER_NOTE = "SAVED_EDIT_CUSTOMER_NOTE";
export const SET_IS_LOADING_CUSTOMER_NOTES = "SET_IS_LOADING_CUSTOMER_NOTES";
export const CLEAR_CUSTOMER_NOTE_API_ERROR = "CLEAR_CUSTOMER_NOTE_API_ERROR";

export const getCustomerRecentNotes = customerId => {
  return {
    type: GET_CUSTOMER_RECENT_NOTES,
    data: {
      customerId: customerId
    }
  };
};

export const saveNewCustomerNote = (customerId, newNote) => {
  return {
    type: SAVE_NEW_CUSTOMER_NOTE,
    data: {
      customerId: customerId,
      newNote: newNote
    }
  };
};

export const saveEditCustomerNote = (customerId, newNote, noteId) => {
  return {
    type: SAVE_EDIT_CUSTOMER_NOTE,
    data: {
      customerId: customerId,
      newNote: newNote,
      noteId: noteId
    }
  };
};

export const deleteCustomerNote = (customerId, noteId) => {
  return {
    type: DELETE_CUSTOMER_NOTE,
    data: {
      customerId: customerId,
      noteId: noteId
    }
  };
};

export const updateIsCustomerNoteEditorOpen = isOpen => {
  return {
    type: UPDATE_IS_CUSTOMER_NOTE_EDITOR_OPEN,
    data: {
      isOpen: isOpen
    }
  };
};

export const updateNewCustomerNote = newNote => {
  return {
    type: UPDATE_NEW_CUSTOMER_NOTE,
    data: {
      newNote: newNote
    }
  };
};

export const updateEditingNote = (noteId, noteContent) => {
  return {
    type: UPDATE_EDITING_NOTE,
    data: {
      noteId: noteId,
      noteContent: noteContent
    }
  };
};

export const updateExpandedNoteId = noteId => {
  return {
    type: UPDATE_EXPANDED_NOTE_ID,
    data: {
      noteId: noteId
    }
  };
};

export const setIsLoadingOnCustomerNotes = isLoading => {
  return {
    type: SET_IS_LOADING_CUSTOMER_NOTES,
    data: {
      loadingCustomerNotes: isLoading
    }
  };
};

export const clearCustomerNoteApiError = () => {
  return {
    type: CLEAR_CUSTOMER_NOTE_API_ERROR
  };
};
